<template>
  <div class="nebIconButton">
    <neb-tooltip v-if="tooltip !== ''"
      :content="tooltip"
    >
      <button class="nebIconButton-button"
        :class="[
          size,
          { selected, disabled }
        ]"
        @click="onClick"
      >
        <neb-icon :name="icon"
          :height="iconSize"
          :width="iconSize"
        ></neb-icon>
      </button>
    </neb-tooltip>

    <button class="nebIconButton-button"
        v-if="tooltip === ''"
        :class="[
        size,
        { selected, disabled }
      ]"
      @click="onClick"
    >
      <neb-icon :name="icon"
        :height="iconSize"
        :width="iconSize"
      ></neb-icon>
    </button>
  </div>
</template>

<script>
import NebIcon from '../../Icon'
import NebTooltip from '../../generic/Tooltip'

export default {
  name: 'NebIconButton',

  components: {
    NebIcon,
    NebTooltip
  },

  props: {
    /**
     * The icon name.
     */
    icon: {
      type: String,
      required: true
    },
    /**
     * The button size. Options: small, medium, large
     */
    size: {
      type: String,
      default: 'small'
    },
    /**
     * Is this button "selected"? Applies a selected stylign to the button when true.
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * Applies a disabled styling to the button and deactivates the click event.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Tooltip text.
     */
    tooltip: {
      type: String,
      default: ''
    }
  },

  computed: {
    iconSize () {
      switch (this.size) {
        case 'small':
        default:
          return '18px'
        case 'medium': return '24px'
        case 'large': return '32px'
      }
    }
  },

  methods: {
    onClick () {
      if (this.disabled) { return }

      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebIconButton {
  &-button {
    box-sizing: border-box;
    overflow: hidden;
    padding: 7px;
    border: solid 1px $pinkish-grey;
    border-radius: 3px;
    background-color: $white;
    color: $pinkish-grey;
    transition: all 0.3s;
    cursor: pointer;

    &:not(.disabled):hover {
      border-color: $tiffany-blue;
      color: $tiffany-blue;
    }

    &.selected {
      border-color: $tiffany-blue;
      color: $tiffany-blue;
      background-color: $duck-egg-blue;
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background-color: $white-four;
    }
  }
}
</style>
